import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SystemLightIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12 5.25C8.28 5.25 5.25 8.28 5.25 12C5.25 15.72 8.28 18.75 12 18.75C15.72 18.75 18.75 15.72 18.75 12C18.75 8.28 15.72 5.25 12 5.25ZM12 17.25C9.1 17.25 6.75 14.89 6.75 12C6.75 9.11 9.1 6.75 12 6.75C14.9 6.75 17.25 9.1 17.25 12C17.25 14.9 14.89 17.25 12 17.25Z"
        fill={color}
      />
      <path
        d="M12 3.54C12.41 3.54 12.75 3.2 12.75 2.79V0.75C12.75 0.34 12.41 0 12 0C11.59 0 11.25 0.34 11.25 0.75V2.79C11.25 3.2 11.59 3.54 12 3.54Z"
        fill={color}
      />
      <path
        d="M4.95998 6.02C5.24998 6.31 5.72998 6.31 6.01998 6.02C6.30998 5.73 6.30998 5.25 6.01998 4.96L4.56998 3.51C4.27998 3.22 3.79998 3.22 3.50998 3.51C3.21998 3.8 3.21998 4.28 3.50998 4.57L4.95998 6.02Z"
        fill={color}
      />
      <path
        d="M3.54 12C3.54 11.59 3.2 11.25 2.79 11.25H0.75C0.34 11.25 0 11.59 0 12C0 12.41 0.34 12.75 0.75 12.75H2.79C3.2 12.75 3.54 12.41 3.54 12Z"
        fill={color}
      />
      <path
        d="M4.95998 17.98L3.50998 19.43C3.21998 19.72 3.21998 20.2 3.50998 20.49C3.79998 20.78 4.27998 20.78 4.56998 20.49L6.01998 19.04C6.30998 18.75 6.30998 18.27 6.01998 17.98C5.72998 17.69 5.24998 17.69 4.95998 17.98Z"
        fill={color}
      />
      <path
        d="M12 20.46C11.59 20.46 11.25 20.8 11.25 21.21V23.25C11.25 23.66 11.59 24 12 24C12.41 24 12.75 23.66 12.75 23.25V21.21C12.75 20.8 12.41 20.46 12 20.46Z"
        fill={color}
      />
      <path
        d="M19.04 17.98C18.75 17.69 18.27 17.69 17.98 17.98C17.69 18.27 17.69 18.75 17.98 19.04L19.43 20.49C19.72 20.78 20.2 20.78 20.49 20.49C20.78 20.2 20.78 19.72 20.49 19.43L19.04 17.98Z"
        fill={color}
      />
      <path
        d="M23.25 11.25H21.21C20.8 11.25 20.46 11.59 20.46 12C20.46 12.41 20.8 12.75 21.21 12.75H23.25C23.66 12.75 24 12.41 24 12C24 11.59 23.66 11.25 23.25 11.25Z"
        fill={color}
      />
      <path
        d="M19.04 6.02L20.49 4.57C20.78 4.28 20.78 3.8 20.49 3.51C20.2 3.22 19.72 3.22 19.43 3.51L17.98 4.96C17.69 5.25 17.69 5.73 17.98 6.02C18.27 6.31 18.75 6.31 19.04 6.02Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SystemLightIcon.displayName = 'SystemLightIcon';
